import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={11} height={11} fill="none" ref={ref} {...props}>
    <g>
      <path
        stroke="#999"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.082 6.36a4.425 4.425 0 0 1-3.929 2.946A3.928 3.928 0 0 1 1.461 6.72m-.236-2.324c.55-1.506 2.24-2.947 3.928-2.947a3.928 3.928 0 0 1 3.693 2.62m.694 3.734a6.374 6.374 0 0 0-.457-1.44 6.374 6.374 0 0 0-1.44.457M.88 2.93c.081.6.158.923.35 1.47a6.374 6.374 0 0 0 1.47-.35"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const IconCycleArrows = memo(ForwardRef);
export default IconCycleArrows;
